import { render, staticRenderFns } from "./page-extension.vue?vue&type=template&id=6999b12e&"
import script from "./page-extension.vue?vue&type=script&lang=js&"
export * from "./page-extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports